import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';

import Buffering from "../components/Buffering"; 
import ShowError from "../components/ShowError";
import Rendition from '../components/Rendition';


import dsd from "../classes/clsDSD";

import { getDataDictionary, getStructure, addStructure, editStructure } from "../utils/utilsDataDictionary";

import D3Graphviz from "../components/D3Graphviz";
import ViewStructure from "../components/ViewStructure";
import ViewDataDictionary from "../components/ViewDataDictionary";
import ViewMetadata from "../components/ViewMetadata";

import FormAttribute from "../components/FormAttribute"

import ListEntityAttributes from "../components/ListEntityAttributes";
import ListStructureAttributes from "../components/ListStructureAttributes";

import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Structure extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.addAttribute = this.addAttribute.bind(this);
        this.removeAttribute = this.removeAttribute.bind(this);
        this.updateAttribute = this.updateAttribute.bind(this);
        this.moveAttributeUp = this.moveAttributeUp.bind(this);
        this.moveAttributeDown = this.moveAttributeDown.bind(this);


        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);
        this.loadedUsedInEntities = this.loadedUsedInEntities.bind(this);
        this.loadedUsedInStructures = this.loadedUsedInStructures.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataDictionary(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (DataDictionary) => {
            let StateChange = {
                renderState: "loaded",
                DataDictionary: DataDictionary,
            };

            // Only set default FormData for 'new' mode
            if (this.state.mode === 'new'){
                StateChange.FormData = {status: 'in use'};
            }

            // Check permission for edit
            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id == DataDictionary.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Structures to this Data Dictionary";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message
            });
        };

        getDataDictionary(this.dsd, id, onLoad, onFail);
        
    };

    loadStructure(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (Structure) => {
            let StateChange = {
                renderState: "loaded",
                Structure: Structure,
                DataDictionary: Structure.DataDictionary,
                FormData: Structure
            };

            // Check permission for edit
            StateChange.OfferEdit = false;
            if (Structure.DataDictionary){

                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsDataDictionary(Structure.DataDictionary._id);
                }

                if (this.dsd.loggedon){
                    if (this.dsd.user.id == Structure.DataDictionary.idUser){
                        StateChange.OfferEdit = true;
                    }
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Structures to this Data Dictionary";
                        break;
                }
            }

            // Fetch DOT from server
            this.fetchViz(id);

            this.setState(StateChange);
        };

        const onFail = (error) => {
            this.setState({
                renderState: error.status || "failed",
                errorMessage: error.errorMessage
            });
        };

        getStructure(this.dsd, id, onLoad, onFail);
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getStructure(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };

    setup(){

        let StateChange = {

            mode: "view",

            idStructure: null,
            idDataDictionary: null,

            DataDictionary: null,
            Structure: null,

            isUpdated: false,
            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,

            dot: null,

            Controls: {
            },

            countRevisions: null,
            countUsedInEntities : null,
            countUsedInStructures : null


        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idStructure = getParam('id', this.props);
        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idDataDictionary){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Dictionary not specified when adding a Structure"
                }
                break;
            default:
                if (StateChange.idDataDictionary){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Dictionary should not be specified for an existing Structure"
                }
                if (!StateChange.idStructure){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Structure not be specified for an existing Structure"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idDataDictionary){
                this.FallBackNavigation = `/datadictionary/${StateChange.idDataDictionary}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Load data based on mode
        if (StateChange.idDataDictionary && StateChange.mode === 'new'){
            this.loadDataDictionary(StateChange.idDataDictionary);
        }

        if (StateChange.idStructure){
            this.loadStructure(StateChange.idStructure);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/structure/${this.state.idStructure}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })

                const onAdd = (idStructure) => {
                    this.props.navigation(`/structure/${idStructure}`);
                };

                const onUpdate = () => {
                    this.refRevision.current.update();
                    this.props.navigation(`/structure/${this.state.idStructure}`);
                };

                const onError = (error) => {

                    this.setState({
                        renderState: "error",
                        errorMessage: error.message,
                        isError: true,
                        error: error
                    });

                };
        
                switch (this.state.mode){
                    case 'new':
                        addStructure(this.dsd, this.state.idDataDictionary, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editStructure(this.dsd, this.state.idStructure, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    addAttribute(){
        
        let FormData = {...this.state.FormData};
        FormData.Attributes = [...(FormData.Attributes || []), {}];
  
        this.setState({"FormData": FormData});
    }

    removeAttribute(seq){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
       FormData.Attributes.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});


    }


    moveAttributeUp(seq){

        let FormData = {...this.state.FormData};
        FormData.Attributes = [...(FormData.Attributes || [])];
        
        // Swap with previous item
        [FormData.Attributes[seq-2], FormData.Attributes[seq-1]] =
        [FormData.Attributes[seq-1], FormData.Attributes[seq-2]];
        
        this.setState({"FormData": FormData});

    }

    moveAttributeDown(seq){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
      
       // Swap with next item
       [FormData.Attributes[seq-1], FormData.Attributes[seq]] =
       [FormData.Attributes[seq], FormData.Attributes[seq-1]];
      
       this.setState({"FormData": FormData});

    }

    updateAttribute(seq, Attribute){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
       FormData.Attributes[seq-1] = Attribute;

       this.setState({"FormData": FormData});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        

        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'concept':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'entity':
                    if (partsVizNodeId.length > 3){
                        switch(partsVizNodeId[2]){
                            case 'structure':
                                this.props.navigation(`/structure/${partsVizNodeId[3]}`);
                                break;
                            case 'enumeration':
                                this.props.navigation(`/enumeration/${partsVizNodeId[3]}`);
                                break;
                        }

                    }else{
                        if (partsVizNodeId.length > 1){
                            this.props.navigation(`/entity/${partsVizNodeId[1]}`);
                        }
                    }
                    break;
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'enumeration':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/enumeration/${partsVizNodeId[1]}`);
                    }   
                    break;
            }

        }

        event.preventDefault();

    };

    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);

    };


    loadedUsedInEntities(count){

        let StateChange = {};

        StateChange.countUsedInEntities = 0;
        if (count){
            StateChange.countUsedInEntities = count;
        }

        this.setState(StateChange);

    }

    loadedUsedInStructures(count){

        let StateChange = {};

        StateChange.countUsedInStructures = 0;
        if (count){
            StateChange.countUsedInStructures = count;
        }

        this.setState(StateChange);

    }

    visualise(){
    
        if (!this.state.Structure){
            return null;
        }




        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>
                </div>
            );
          } catch (error) {
            return <div/>
          }
    };

    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":
                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Structure</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox><ShowError error={this.state.error}/></PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.StructureStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.FormAttributes()}

                                    <Revision ref={this.refRevision}  idAbout={this.state.idStructure}/>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Structure</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewStructure Structure={this.state.Structure}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countAttributes = 0;
                        if (this.state.Structure.Attributes){
                            countAttributes = this.state.Structure.Attributes.length;
                        }

                        let countUsedIn = null;
                        if (this.state.countUsedInEntities !== null && this.state.countUsedInStructures !== null){
                            countUsedIn = this.state.countUsedInEntities + this.state.countUsedInStructures;
                        }

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Structure:{this.state.Structure.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewStructure Structure={this.state.Structure}/>

                                <br/>

                                <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>


                                <div label={`Attributes(${countAttributes})`}>

                                    {isArray(this.state.Structure.Attributes) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Name</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                    <PD.Th>Data Type</PD.Th>
                                                    <PD.Th>Structure / Enumeration</PD.Th>
                                                    <PD.Th>Occurs</PD.Th>
                                                    <PD.Th>Required</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Structure.Attributes.map(
                                                        (Attribute, pos) => 
                                                        {
                                                            return (
                                                                <PD.Tr key={pos}>
                                                                    <PD.Td>
                                                                        {Attribute.name}
                                                                    </PD.Td>
                                                                   
                                                                    <PD.Td>
                                                                        <PD.MdPresent>{truncate(Attribute.description, 1000)}</PD.MdPresent>                                                                        
                                                                    </PD.Td>

                                                                    {(() => {
                                                                        switch (Attribute.type) {
                                                                            case "structure":
                                                                                if (Attribute.Structure){
                                                                                    return (
                                                                                        <>
                                                                                            <PD.Td/>
                                                                                            <PD.Td>
                                                                                                <PD.PdNavLink to={"/structure/" + Attribute.Structure._id} > {Attribute.Structure.name}</PD.PdNavLink>
                                                                                            </PD.Td>
                                                                                        </>
                                                                                    );
                                                                                }                                                                                
                                                                                return (
                                                                                    <>
                                                                                        <PD.Td/>
                                                                                        <PD.Td/>
                                                                                    </>    
                                                                                )
                                                                                break;
                                                                            default:
                                                                                return(
                                                                                    <>
                                                                                        <PD.Td>
                                                                                            {Attribute.dataType}
                                                                                        </PD.Td>
                                                                                        <PD.Td>
                                                                                            {Attribute.Enumeration &&
                                                                                                <PD.PdNavLink to={"/enumeration/" + Attribute.Enumeration._id} > {Attribute.Enumeration.name}</PD.PdNavLink>
                                                                                            }
                                                                                        </PD.Td>
                                                                                    </>
                                                                                )
                                                                        }
                                                                    })()}


                                                                    <PD.Td>
                                                                        {Attribute.occurs}
                                                                    </PD.Td>

                                                                    <PD.Td>
                                                                        {Attribute.required}
                                                                    </PD.Td>


                                                                </PD.Tr>

                                                            )
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }

                                </div>

                                    <div label='Data Dictionary'>
                                        <ViewDataDictionary DataDictionary={this.state.DataDictionary} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Structure} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idStructure}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/structures"
                                            id={this.state.idStructure}
                                        />
                                    </div>


                                    <div label={<span>used in({countUsedIn === null ? <Buffering/> : countUsedIn})</span>} data-forcerender="true">
                                        {this.state.countUsedInEntities > 0 &&
                                            <PD.Heading level='2'>Entities</PD.Heading>
                                        }
                                        <ListEntityAttributes filters={{usesIdStructure:this.state.idStructure}} columns={{owner:true, logicalmodel:true, entity:true}} onLoad={this.loadedUsedInEntities}/>
                                        {this.state.countUsedInStructures > 0 &&
                                            <PD.Heading level='2'>Structures</PD.Heading>
                                        }
                                        <ListStructureAttributes filters={{usesIdStructure:this.state.idStructure}} columns={{owner:true, datadictionary:true, structure:true}} onLoad={this.loadedUsedInStructures}/>
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };


    FormAttributes(){

        let seqNext = 1;
        if (this.state.FormData.Attributes){
            seqNext = this.state.FormData.Attributes.length + 1;
        }
        return (
            <fieldset>
                <legend>Attributes</legend>
                {this.state.FormData.Attributes &&
                    this.state.FormData.Attributes.map(
                        (Attribute, posAttribute) => 
                        {
                            let seq = posAttribute+1;
                            return(
                                this.FormAttribute('edit', seq, Attribute)
                            )
                        }
                    )
                }
                {this.FormAttribute('new', seqNext)}
            </fieldset>
        );

    }

    FormAttribute(mode, seq, Attribute = {}){

        let onMoveUp = null;
        if (seq>1) {
            onMoveUp = this.moveAttributeUp;
        }

        let onMoveDown = null;
        if (this.state.FormData.Attributes){
            if (seq<this.state.FormData.Attributes.length) {
                onMoveDown = this.moveAttributeDown;
            }
        }

        let key=null;
        if (Attribute._id){
            key = Attribute._id;
        }
        else if(Attribute._tempId){
            key = Attribute._tempId;
        }
        else{
            Attribute._tempId = `temp_${Date.now()}`;
            key = Attribute._tempId;
        }


        return(
            <div>
                <FormAttribute 
                    key={key} 
                    mode={mode} parent={this} 
                    onAdd={this.addAttribute}
                    onRemove={this.removeAttribute}
                    onUpdate={this.updateAttribute}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    Attribute={Attribute} 
                    seq={seq}
                />                
            </div>
        )
    }


};

// Wrap and export
export default function Structure_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Structure {...props} navigation={navigation} location={location} params={params} />;
  }
